export const projectWorkspacePath = (projectId: string, resource?: "chats" | "files", organizationId?: string): string => {
    const resourcePath = resource ? `/${resource}` : "";
    const path = `/projects/${encodeURIComponent(projectId)}${resourcePath}`;
    if (!organizationId) return path;

    const query = new URLSearchParams({ organizationId });
    return `${path}?${query.toString()}`;
};
